const faqs = [
  {
    "@type": "Question",
    name: "Kostar det något att annonsera sin lokal som hyresvärd?",
    acceptedAnswer: {
      "@type": "Answer",
      text: `Det kostar ingenting att registrera sig, få förfrågningar från hyresgäster eller att annonsera en lokal via Vakansa.
  
  Vi är en provisionsbaserad plattform som marknadsför era lokaler och förmedlar era lokaler till hyresgäst som hör av sig direkt till er vid intresse. När du som hyresvärd fått kontakt med en hyresgäst ni vill avtala en förhyrning med, kommer vi på Vakansa att fakturera er 15% av hyresintäkterna ni får in varje månad i maximalt 12 månader.
  
  Se Hyr ut lokal för mer info om hur vi tar betalt när vi hittat en hyresgäst åt er eller läs våra användarvillkor här.`,
    },
  },
  {
    "@type": "Question",
    name: "Vad kostar det att använda Vakansa vid uthyrning av lokal?",
    acceptedAnswer: {
      "@type": "Answer",
      text: `Du förbinder dig inte till någon kostnad genom att använda Vakansa Bas utan betalar först när du tecknat ett hyresavtal muntligt eller skriftligt med en hyresgäst som Vakansa förmedlat. Detta ska du upplysa Vakansa om så fort detta skett.
  
  Vid lyckad lokalförmedling tar vi på Vakansa en förmedlingsavgift på 15% av hyresintäkten i upp till 12 månader. Med hyresintäkten avser vi hyresbeloppet exklusive moms per månad som Hyresvärden fakturerat. Med hyresbelopp avses det totala hyresbeloppet för hela den avtalade hyresperioden, även om hyresperioden är uppdelad i flera kortare hyresavtal inom en 12 månadersperiod eller om hyran skulle höjas eller sänkas.
  
  12 månadersperioden räknas från fakturadatumet som Hyresvärden satt för sin första inbetalda hyra från Hyresgästen. Om hyresgästen fortsätter att hyra efter denna 12 månadersperiod så utgår ingen förmedlingsavgift.
  
  Läs mer om Vakansa Bas och Mest på Hyr ut lokal.`,
    },
  },
  {
    "@type": "Question",
    name: "Vilken information om min lokal behöver jag för att hyra ut via Vakansa?",
    acceptedAnswer: {
      "@type": "Answer",
      text: `För varje lokal som läggs upp på Vakansa behöver du ange:
  
  - Vilken typ av lokal det är.
  - Hur stort utrymmet är i kvadratmeter.
  - Antal personer som lokalen är lämplig för (se brandföreskrifter).
  - En beskrivning av lokalen där du kan ange hur man tar sig till lokalen, vad som gör den unik och vilka aktiviteter som inte kan göras här.
  - Vilka bekvämligheter som ingår samt minst fyra (4) bilder på lokalen.
  
  Önskar ni hjälp med detta är ni välkomna att kontakta oss på info@vakansa.se

  OBS!: Det är inte tillåtet att uppge kontaktuppgifter eller andra ledande uppgifter i beskrivningstexten som skulle göra att ni kringgår Vakansas tjänster och våra användarvillkor. Vid upptäckt kommer vi debitera er 500 kr/annons ex moms i straffavgift
  `,
    },
  },
  {
    "@type": "Question",
    name: "Hur hyr jag ut min lokal via Vakansa?",
    acceptedAnswer: {
      "@type": "Answer",
      text: `
      För att kunna hyra ut din lokal behöver du först registrera ett konto för att skapa annonser i Vakansa. Efter att du aktiverat ditt konto via aktiveringsmejlet som skickats till den mejl du angett när du skapat kontot, kan du logga in på ditt konto. Väl inloggad kommer du till din egna portal, även kallad “mina sidor”, på Vakansa där du kan “skapa annons” i din portal. Här ovan under rubriken "Vilken information om min lokal behöver jag för att hyra ut via Vakansa?" kan du hitta svar på vilka frågor du behöver svara på för att skapa en annons. En väldigt smidig och lätt process enligt våra befintliga användare.
      `,
    },
  },
  {
    "@type": "Question",
    name: "Hur går uthyrningsprocessen till?",
    acceptedAnswer: {
      "@type": "Answer",
      text: `
      När du publicerat en annons för din lokal kan besökare anmäla intresse på er/era annonser genom att skicka en förfrågan. Dessa skickas till dig via oss på Vakansa i form av ett "matchningsmejl" som representerar lokalförmedlingen. Det är via detta matchningsmejl som vi följer uthyrningsprocessen. Ni får i matchningsmejlet information om hyresgästens kontaktuppgifter, organisationsnummer och behovsbeskrivning. Vidare kan ni välja att kontakta hyresgästen och ta en visning eller avböja uthyrning. När ni väl genomfört en visning och kommit överens om en förhyrning så ordnar ni med avtal och allt det praktiska själva för att gå i mål med uthyrningsprocessen. Oavsett om en uthyrning blir av eller inte är det ert ansvar att informera oss på Vakansa om hur det går.

      OBS: För att vi på Vakansa ska kunna upprätthålla vårt ansvar åtar Ni er som användare av våra tjänster, att besvara våra kontrollfrågor om hur uthyrningsprocessen med förmedlad part fortskrider. Om du som Hyresvärd underlåter dig att svara, efter att vi gjort våra tre (3) kontaktförsök, utgår en straffavgift. Om du som Hyresgäst underlåter dig att svara, efter att vi gjort våra tre (3) kontaktförsök, kommer en straffavgift om 500 kr debiteras din organisation. Detta i enlighet med våra användarvillkor.
      `,
    },
  },
  {
    "@type": "Question",
    name: "Kan man tacka nej till hyresgäster ni förmedlar?",
    acceptedAnswer: {
      "@type": "Answer",
      text: `
      Så länge er annons eller annonser är aktiva kan ni ta emot hur många förfrågningar från potentiella hyresgäster som helst. Ni har alltid slutordet och vi hjälper er gärna med att skriva avtal när ni väl bestämmer er för att ta emot en hyresgäst från oss.
      `,
    },
  },
  {
    "@type": "Question",
    name: "Hur marknadsför Vakansa min yta?",
    acceptedAnswer: {
      "@type": "Answer",
      text: `
      I dagens digitala värld så är det svårt att tränga igenom bruset. Detta får du hjälp med helt kostnadsfritt på Vakansa genom att skapa annonser och publicera dina lokaler för uthyrning. Vi jobbar jämt och ständigt med exponeringen av annonser via sociala medier, genom att ranka på sökmotorer som Google och via våra samarbetspartners. Du får hyresgästförfrågningar och väljer själv vilka du vill ta emot eller neka.

      Vi vill göra det så enkelt som möjligt för fler att välja andrahands lokaler i första hand!
      `,
    },
  },
  {
    "@type": "Question",
    name: "Kan ni hjälpa till med att skriva kontrakt parterna emellan?",
    acceptedAnswer: {
      "@type": "Answer",
      text: `
      Vakansa har två prismodeller, Vakansa Bas och Vakansa Mest, varav Vakansa Mest omfattar bland annat att hjälpa till att skriva ett lämpligt hyresavtal. Önskar ni enbart hjälp med att upprätta ett avtal ber vi er återkomma för att kunna ge er ett fast pris för den tjänsten.
      `,
    },
  },
  {
    "@type": "Question",
    name: "Är min lokal försäkrad via Vakansa?",
    acceptedAnswer: {
      "@type": "Answer",
      text: `
       Vakansa ansvarar inte för skador som uppkommer i lokaler, på fönster, skyltfönster, dörrar eller portar som hör till lokaler eller som finns i direkt anslutning till lokaler. Detta gäller oavsett vem eller vad som orsakat skadan. Varje Hyresvärd och Hyresgäst ansvarar för sitt eget försäkringsbehov och vi rekommenderar att man åtminstone ska ha en verksamhetsförsäkring.

       Vi på Vakansa kan ordna en särskild försäkring vid samnyttjande av lokaler mellan flera parter, via vår försäkringspartner.
      `,
    },
  },
  {
    "@type": "Question",
    name: "Vad ingår i ert Vakansa Mest upplägg?",
    acceptedAnswer: {
      "@type": "Answer",
      text: `
      Hjälp med uthyrning av lokal: Vakansa Mest innebär att vi sköter de delar av uthyrningen eller samnyttjandet som du som hyresvärd (fastighetsägare eller kontraktsägande hyresgäst) behöver avlastning med.

       Detta är en tjänst som finns utöver Vakansa Bas nivån där du som hyresvärd kan registrera ett konto, publicera annonser gratis och få förfrågningar på dina lokaler som du hanterar själv.

       Med Vakansa Mest hjälper vi alltså dig med det praktiska utöver att hitta en hyresgäst.

       - Att upprätta ett andrahandskontrakt parterna emellan.
       - Ha koll på vad som gäller rörande moms, oavsett om lokalen är en momsad lokal (en lokal som hyrs ut ex moms) eller icke momsad lokal (en lokal där ingen moms läggs på hyran).
       - Ordna med lämpligt bokningssystem.
       - Implementera ett modernt digitalt låssystem.
       - Kolla upp försäkringsfrågor och hitta lämplig försäkring.

       Vi kan också vid behov hjälpa till med andra administrativa och operativa uppgifter såsom:

       - Visningar.
       - Kreditupplysningar.
       - Deposition.
       - Hyresinbetalningar.
       - En "hot-line", likt en jour, som ni kan ringa vid behov av hjälp, felanmälan eller support att hantera vissa frågor.
       - Särskild försäkring för samnyttjande av lokaler mellan flera parter.

        Med andra ord - ni hanterar allt ovan om ni väljer vår Vakansa Bas modell. Vilket sker automatiskt när ni registrerar ett konto och skapar annonser. Läs mer om Vakansa Mest här.
      `,
    },
  },
  {
    "@type": "Question",
    name: "Vad kostar Vakansa mest?",
    acceptedAnswer: {
      "@type": "Answer",
      text: `
      Det är pris på förfrågan som gäller då det beror på ert specifika behov, era lokaler och hur mycket ni önskar att vi hjälper till i relation till det ni själva vill och/eller kan göra.
      `,
    },
  },
  {
    "@type": "Question",
    name: "Får jag annonsera på andra ställen samtidigt?",
    acceptedAnswer: {
      "@type": "Answer",
      text: `
      Vi på Vakansa kräver ingen ensamrätt och vill inte låsa in företag eller fastighetsägare som önskar hyra ut sina lokaler. Vill ni använda er av andras digitala tjänster är det fritt fram.
      `,
    },
  },
  {
    "@type": "Question",
    name: "Vad ska jag ta betalt för min yta?",
    acceptedAnswer: {
      "@type": "Answer",
      text: `
       Enkelt beskrivet så är det helt upp till er och i relation till vad som är rimligt i ert närområde. Vårt tips är att lägga sig lite lägre för att locka intresserade hyresgäster och därefter diskutera tillägg som skrivare, fika, parkering, mötesrum, bredband, reception och andra tjänster som ni kan lägga till. Ett annat sätt är skriva ett all-inclusive pris! Det är så coworking aktörer gör idag på marknaden.

       Vill ni ha hjälp med prissättning så kan ni med fördel höra av er till oss på info@vakansa.se med bilder, adress, kvadratmeter ni önskar hyra ut och annan information så hjälper vi er.
      `,
    },
  },
  {
    "@type": "Question",
    name: "Hanterar eller begär Vakansa depositioner?",
    acceptedAnswer: {
      "@type": "Answer",
      text: `
      Vakansa tar inte och hanterar inga depositioner via vår plattform, men kan vara behjälplig i frågor som rör depositioner. Vi rekommenderar alltid Hyresvärdar att ta en deposition i syfte att ha en säkerhet vid eventuella framtida risker och det är även sedvanligt att lämna en deposition som Hyresgäst. Depositionen brukar ligga på mellan 1-6 månadshyror för längre uthyrningar eller en kännbar summa vid kortare uthyrningar, beroende på lokalens storlek och ändamål. Vi rekommenderar även att alltid ta betalt i förskott för en förhyrning, på samma sätt som man gör med en bostadshyresrätt.
      `,
    },
  },
  {
    "@type": "Question",
    name: "Hur sker betalningen och vilka är betalningsvillkoren?",
    acceptedAnswer: {
      "@type": "Answer",
      text: `
      Fakturering av förmedlingsavgiften sker i efterskott digitalt och skickas som PDF faktura från vårt bokföringsprogram Bokio. Ni kan välja om ni vill ha en faktura varje månad eller kvartalsvis.

      Betalningsvillkor är 30 dagar netto. Mervärdesskatt tillkommer på samtliga belopp enligt dessa villkor. Våra fullständiga användarvillkor finner du här - Användarvillkor.
      `,
    },
  },
  {
    "@type": "Question",
    name: "Tar ni någon kreditupplysning på hyresgästerna?",
    acceptedAnswer: {
      "@type": "Answer",
      text: `
      Vi har som krav på Vakansa att alla hyresgäster måste ange organisationsnummer för att kunna skicka en förfrågan på lokal. Detta ger er som hyresvärd möjligheten att göra en kreditupplysning själva. Med Vakansa Bas tar vi inte ansvar för kreditupplysningar. Behöver ni hjälp med detta hänvisar vi till Vakansa Mest.
      `,
    },
  },
  {
    "@type": "Question",
    name: "Vad förbinder jag mig till när jag använder Vakansa?",
    acceptedAnswer: {
      "@type": "Answer",
      text: `
      Du förbinder dig att följa våra användarvillkor. Dessa finner du här - Användarvillkor.
      `,
    },
  },
];

export const jsonLdSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs,
};
